import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Checkbox, FormGroup, FormHelperText, FormLabel } from "@mui/material";

import {
  Card, CardHeader, CardContent, Typography, Button, Grid, MenuItem, Select, TextField, FormControl, InputLabel, TablePagination, TableContainer, Paper, Dialog, DialogTitle, DialogContent, Input, RadioGroup, FormControlLabel, Radio, Tooltip, CircularProgress, DialogActions, List, ListItem, ListItemAvatar, Avatar, ListItemText
} from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import { Close, Edit, RemoveRedEye } from '@mui/icons-material';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import TableView from 'app/shared/Tableview/Tableview';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import { useFormik } from 'formik';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import Div from '@jumbo/shared/Div';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import { blue, green } from '@mui/material/colors';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import ExcelFileUpload from '@jumbo/shared/ExcelUpload/ExcelUpload';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { DataGrid } from '@mui/x-data-grid';
import { useJumboApp } from '@jumbo/hooks';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
const atLeastTwoValuesRequired = (array) => {
  return array.filter((item) => item?.trim() !== '').length >= 2;
};

const validationSchema = Yup.object({
  FL_PARTY_NAME: Yup.string().required('Company Name is required'),
  FL_PARTY_ADDR1: Yup.string().required('Address Line 1 is required'),
  FL_PARTY_COUNTRY: Yup.string().required('Country is required'),
  FL_PARTY_STATE: Yup.string().required('State is required'),
  FL_PARTY_CITY: Yup.string().required('City is required'),
  // FL_PARTY_ZIPCODE: Yup.string().required('PostalCode is required'),
  FL_PARTY_PHONENO: Yup.string().required('Phone No is required'),
  // FL_PARTY_EMAIL: Yup.string().email('Invalid email').required('Email is required'),
  // FL_PARTY_TERMCODE: Yup.string().required('Payment Terms is required'),
  // FL_PARTY_SHIPCODE: Yup.string().required('Shipped By is required'),
  // FL_PARTY_NAT_OF_ORG: Yup.string().required('Nature of Organization is required'),
  // FL_PARTY_BUSINESS_TYPE: Yup.string().required('Business Type is required'),
  // FL_PARTY_TRAD_MEMR: Yup.string().required('Business Registration No is required'),
  // kycUpload: Yup.mixed().required('KYC Upload is required'),
  // FL_PARTY_AUTR_PERSON: Yup.string().required('Authorized By is required'),
  // FL_PARTY_LIMIT: Yup.number().required('Limit is required'),
  // FL_ACCOUNT_MANAGER: Yup.string().required('Account Manager is required'),
  FL_SALES_EXECUTIVE: Yup.string().required('Sales Executive is required'),
  // brokerName: Yup.string(),
  // FL_PARTY_LEAD_OF_SOURCE: Yup.string().required('Lead Source is required'),
  FL_PARTY_TYPE: Yup.string().required('Party Group is required'),
  // FL_PARTY_BANK_NAME: Yup.string().required('Bank Name is required'),
  // FL_PARTY_BANK_ACNO: Yup.string().required('Account Number is required'),
  // FL_PARTY_BANK_BR_NAME: Yup.string().required('Branch Name is required'),
  // FL_PARTY_BANK_BR_ADDR: Yup.string().required('Branch Address is required'),
  // FL_PARTY_BANK_AC_TYPE: Yup.string().required('Account Type is required'),
  // FL_PARTY_BANK_IFSC_TYPE: Yup.string().required('Branch Code is required'),
  // FL_PARTY_BANK_IFSC_NO: Yup.string().required('Branch IFSC is required'),
  // FL_PARTY_AC_PER_NAME: Yup.string().required('First Name is required'),
  // acc_lastName: Yup.string().required('Last Name is required'),
  // acc_phoneCountryCode: Yup.string().required('Country Code is required'),
  // acc_phoneNo: Yup.string().required('Phone No is required'),
  // acc_faxCountryCode: Yup.string().required('Country Code is required'),
  // acc_faxNo: Yup.string().required('Fax No is required'),
  // FL_PARTY_AC_PER_EMAIL: Yup.string().email('Invalid email format').required('Email is required'),
  // promotorFirstName0: Yup.string().required('First name is required'),
  // promotorLastName0: Yup.string().required('Last name is required'),
  // promotorEmail0: Yup.string().email('Invalid email format').required('Email is required'),
  // promotorDesignation0: Yup.string().required('Designation is required'),
  // promotorMobileNo0: Yup.string().required('Promoter is required'),
  // promotorCountryCode0: Yup.string().required('Country Code is required'),

});

const BindDisc = ({ setgrouppartydisc,grouppartydisc, Data }) => {
  const [open, setOpen] = React.useState(false);
  const [excelfile, setExcelfile] = useState(Data?.FL_DISC_GROUP || '');
  const [loading, setLoading] = React.useState(false);
  const swal = useSwalWrapper();
  const handlePartyDisBind = async () => {
    const formData = new FormData();
    // formData.append('excelfile', excelfile);
    // formData.append('partyId', Data.ID);
    setLoading(true);
    await jwtAuthAxios.post('/discount/updatePartyDiscGroup', {partyId:Data.ID,grpId:excelfile}).then(res => {
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      setOpen(false)
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })
    }).finally(e => setLoading(false))
  }
  return (
    <Div sx={{ display: 'flex', alignItems: 'center' }}>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={700}
      >
        {/* <DialogContent> */}
        <Card sx={{ width: 700 }}>
          <CardHeader
            title={<Typography variant="h4">Discount Mapping </Typography>}
            subheader={
              <Typography sx={{ mt: 1, color: 'text.secondary' }}>
                For :- {Data['COMPANY NAME']}
              </Typography>
            }
          />
          {/* <ExcelFileUpload
            onFileUpload={(file) => {
              setExcelfile(file);
            }}
          /> */}
          <FormControl fullWidth  sx={{mx:3,maxWidth:'600px'}}>
      <InputLabel id="select-label">Select an discount Group</InputLabel>
      <Select
        labelId="select-label"
        id="select"
        label='Select an discount Group'
        value={excelfile || ''}
        onChange={(e)=>setExcelfile(e.target.value)}
      >
        <MenuItem key={'NO'} value={'0'}>No Disc</MenuItem>
        {grouppartydisc?.data?.map((option) => (
          <MenuItem key={option.FL_GPID} value={option.FL_GPID}>
            {option.FL_PARA_VALUE}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
          <DialogActions>
            <LoadingButton loading={loading} onClick={handlePartyDisBind} variant="contained">
              Submit
            </LoadingButton>
          </DialogActions>
        </Card>
      </Dialog>
      {/* </DialogContent> */}
      <Tooltip title={`Bind Discount`}><Div sx={{ position: 'relative' }}>
        <Fab
          disabled={!Data?.KEY}
          aria-label="Bind Discount"
          color="primary"
          size='small'
          onClick={() => setOpen(true)}
        >
          <BubbleChartIcon />
        </Fab>
      </Div></Tooltip></Div>
  )
}
const LinkComp = ({ Data, callback }) => {
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const timer = React.useRef();
  const swal = useSwalWrapper()
  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };
  const {curr} = useJumboAuth()
  console.log(Data.FL_PARTY_API_CURR_RATE)
  const [state, setState] = React.useState({
    MEMO: Data.MEMO == 'Y',
    HOLD: Data.HOLD == 'Y',
    AVAILABLE: Data.AVAILABLE == 'Y',
    API: Data.API == 'Y',
    FTP: Data.FTP == 'Y',
    FL_PARTY_API_CURR_RATE:Data.FL_PARTY_API_CURR_RATE  || curr?.Rate
  });
useEffect(()=>{
  setState({
    MEMO: Data.MEMO == 'Y',
    HOLD: Data.HOLD == 'Y',
    AVAILABLE: Data.AVAILABLE == 'Y',
    API: Data.API == 'Y',
    FTP: Data.FTP == 'Y',
    FL_PARTY_API_CURR_RATE:Data.FL_PARTY_API_CURR_RATE  || curr?.Rate
  });

},[Data])
  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };
  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  
  const handleRenewKey = async() => {
     if(window.confirm('Are You Sure To Re Grenerate Key')){
      
      if (!loading) {
        setSuccess(false);
        setLoading(true);
        jwtAuthAxios.post('/master/partyApiManage', {
          "type": "KEY",
          "partyId": Data.ID
        }).then(res => {
          swal.fire({
            icon: 'success',
            text: res.data.message,
          });
          setSuccess(true);
          setLoading(false);
          callback()
        }).catch(e => {
          swal.fire({
            icon: 'error',
            text: 'Internal server Error',
          })
        })
      }
    }

  };
  const handleButtonClick = () => {
    setOpen(true); return
    if (!loading) {
      setSuccess(false);
      
    }
  };
 
  // <Tooltip title="View Details">
  //   <Button >
  //     <LinkOutlinedIcon />
  //   </Button>
  // </Tooltip>
  

  const { MEMO, HOLD, AVAILABLE, FTP, API,FL_PARTY_API_CURR_RATE } = state;
  const error = [MEMO, HOLD, AVAILABLE].filter((v) => v).length <= 0;
  const errors = [FTP, API].filter((v) => v).length <= 0;
  const HandleSubmit = () => {
    setLoading(true);
      jwtAuthAxios.post('/master/partyApiManage', {
        "type": "PRIVILEGES",
        "partyId": Data.ID,
        "state":state
      }).then(res => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        callback();
        setOpen(false)
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        })
      }).finally((e)=>{
        setLoading(false);
      })
  };

  return (
    <Div sx={{ display: 'flex', alignItems: 'center' }}>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={700}
      >
        <DialogTitle>Set User Privileges</DialogTitle>
        <ListItem >
            <ListItemText  primary={`Key :- ${Data.KEY}`}/>
            <Tooltip><ListItemAvatar  onClick={handleRenewKey}>
            <Avatar
              alt={Data.KEY}
            >
              <AutorenewIcon />
              {loading && (
          <CircularProgress
            size={50}
            sx={{
              color: green[500],
              position: 'absolute',
              top: -6,
              left: -6,
              zIndex: 10,
            }}
          />
        )}
            </Avatar>
          </ListItemAvatar></Tooltip>
        </ListItem>
        {/* <DialogContent>API key:- {Data.API}</DialogContent> */}
        <Div sx={{ display: 'flex' }}>
          <FormControl required
            error={errors} sx={{ m: 3 }} component="fieldset" variant="standard">
            <FormLabel component="legend">Assign Access</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox checked={API} onChange={handleChange} name="API" />
                }
                label="API"
              />
              <FormControlLabel
                control={
                  <Checkbox checked={FTP} onChange={handleChange} name="FTP" />
                }
                label="FTP"
              />
            </FormGroup>
            <FormHelperText sx={{ mt: 'auto' }}>Be careful</FormHelperText>
          </FormControl>
          <FormControl
            required
            error={error}
            component="fieldset"
            sx={{ m: 3 }}
            variant="standard"
          >
            <FormLabel component="legend">Status</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox checked={AVAILABLE} onChange={handleChange} name="AVAILABLE" />
                }
                label="AVAILABLE"
              />
              <FormControlLabel
                control={
                  <Checkbox checked={HOLD} onChange={handleChange} name="HOLD" />
                }
                label="HOLD"
              />
              <FormControlLabel
                control={
                  <Checkbox checked={MEMO} onChange={handleChange} name="MEMO" />
                }
                label="MEMO"
              />
            </FormGroup>
            <FormHelperText>Please Select At Least One</FormHelperText>
            
           
          <TextField
      label="Party Conversonal Rate"
      type="number"
      value={FL_PARTY_API_CURR_RATE}
      onChange={(event) => {
        setState({
          ...state,
          FL_PARTY_API_CURR_RATE: event.target.value,
        });
      }}
      InputProps={{ inputProps: { min: 1 } }}
      sx={{ mb: 2 }}
      variant="outlined"
      fullWidth
    />
          </FormControl>
         
        </Div>
        <LoadingButton loading={loading} variant="contained" sx={{ borderRadius: 0 }} onClick={HandleSubmit}>Submit</LoadingButton>
      </Dialog>
      <Tooltip title={`${Data.API ? 'Unlink' : 'Link'} Api`}><Div sx={{ position: 'relative' }}>
        <Fab
          aria-label="save"
          color="primary"
          size='small'
          sx={buttonSx}
          onClick={handleButtonClick}
        >
          {success ? <CheckIcon /> : Data.API ? <LinkOffOutlinedIcon /> : <LinkOutlinedIcon />}
        </Fab>
        {loading && (
          <CircularProgress
            size={50}
            sx={{
              color: green[500],
              position: 'absolute',
              top: -6,
              left: -6,
              zIndex: 10,
            }}
          />
        )}
      </Div></Tooltip>
      {/* <Div sx={{m: 1, position: 'relative'}}>
        <Button
            variant="contained"
            sx={buttonSx}
            disabled={loading}
            onClick={handleButtonClick}
        >
            Accept terms
        </Button>
        {loading && (
            <CircularProgress
                size={24}
                sx={{
                    color: green[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                }}
            />
        )}
    </Div> */}
    </Div>
  );
};

const Party = () => {
  const [view, setView] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [Data, setData] = useState([]);
  const [isDisabledflg, setisDisabledflg] = useState(false);
  const [selectedPartyData, setSelectedPartyData] = useState(null);
  const [grouppartydisc, setgrouppartydisc] = useState({data:[]});
  const swal =useSwalWrapper()
  // useEffect(async () => {
  //   getallparty
  //   }, [])
  const fetPiscname = async () => {
     await jwtAuthAxios.get('master/getglobleparaval?name=PARTY_DISC_GROUP').then(res => {
      setgrouppartydisc({...grouppartydisc,data:res.data?.rows})
    }).catch(alert)
  }
  const fetchallPname = async () => {
    let transactionData = await jwtAuthAxios.get(`master/getallpartyname`).then(data => {
      setData(data.data.data)
    }).catch((err)=>swal.fire({ icon:'error',text:err}))
    setCurrentType('details')
  }
  useEffect(async () => {
    fetchallPname()
    fetPiscname()

    // let detailsData = await modifyArrayOfObjectsKeys(transactionData, { FL_PID: 'ID', FL_INVOICE_NO: "INVOICE", FL_NATURE: 'NATURE', FL_FROM_NAME: 'FROM', FL_TO_NAME: 'TO', FL_TO_PROC: 'TYPE', FL_PCS: "PCS", FL_WGT: 'WGT', FL_RATE: 'RATE', FL_DISCPER: 'DISC', FL_AD_RATE: 'AD', FL_NET_RATE: "NET", FL_NET_VALUE: "NER VAL", FL_CREATED_AT: "DATE", FL_UPD_DET: 'UPDATE DATE ' })
  }, [])
  const handleDetailView = async (DATA, TYPE) => {
    // setData([])
    await jwtAuthAxios.get('master/getparty/' + DATA).then(res => {
      setSelectedPartyData(res.data.data)
      TYPE == 'view' && setisDisabledflg(true)
      setView('add')
    })
    // setCurrentType('DETAIL')
    // let Data = await getTransactionDetail(`pid=${e.ID}`)
    // setData(Data)
  }
  // const handleEdit = (e) => {
  //   console.log(e);
  // }
  let columns= [ //{ field: 'ID', headerName: 'ID' },
                  { field: 'COMPANY NAME', flex: 1, headerName: 'Company Name' },
                  { field: 'FL_PARTY_PHONENO', flex: 1, headerName: 'Phone' },
                  { field: 'FL_PARTY_EMAIL', flex: 1, headerName: 'Email' },
                  { field: 'PGROUP', flex: 1, headerName: 'Party  Group' },
                  { field: 'Actions', flex: 1, headerName: 'Action',renderCell:({row})=><Div sx={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
            {row.PARTY_TYPE == '34' && <><LinkComp Data={row} callback={fetchallPname} />
            <BindDisc grouppartydisc={grouppartydisc} setgrouppartydisc={setgrouppartydisc} Data={row} /></>}
            <Fab size='small' color="primary" sx={{ boxShadow: 'none',p:2 }} onClick={() => handleDetailView(row.ID, 'view')}><RemoveRedEye /></Fab>
            <Fab size='small' color="primary" sx={{ boxShadow: 'none' }} onClick={() => handleDetailView(row.ID, 'edit')}><Edit /></Fab>
          </Div> },
                ]
  return (
    <>
      <Grid container alignItems={'center'} sx={{ mb: 2 }} justifyContent={'space-between'}>
        <Typography variant="h1" >
          Customer
        </Typography>
        {view == 'add' ? <Button variant="contained" onClick={() => { setView(null) }} color="primary"> Back To Main </Button> : <Button variant="contained" onClick={() => { setView('add') }} color="primary"> Add New Customer </Button>}
      </Grid>
      {
        view == 'add' ? <AddNewParty setView={setView} partyData={selectedPartyData} isDisabledflg={isDisabledflg} /> : Data.length > 0 ?
         <><Paper>
          <DataGrid
            rows={Data || []}
            columns={columns}
            autoHeight
            density='standard'
            getRowId={(row) => row['ID']}
            pageSizeOptions={[50]}
            disableRowSelectionOnClick
          /></Paper>
         {/* <TableView body={Data} actions={currentType == 'details' ? (row) => (
          <Div sx={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
            {row.PARTY_TYPE == '34' && <><LinkComp Data={row} callback={fetchallPname} />
            <BindDisc Data={row} /></>}
            <Fab size='small' color="primary" sx={{ boxShadow: 'none' }} onClick={() => handleDetailView(row.ID, 'view')}><RemoveRedEye /></Fab>
            <Fab size='small' color="primary" sx={{ boxShadow: 'none' }} onClick={() => handleDetailView(row.ID, 'edit')}><Edit /></Fab>
          </Div>
        ) : (row) => (
          <div>
            <Button onClick={() => handleEdit(row)}><Edit /></Button>
          </div>
        )} /> */}
         </>
        : <TableSkeleton cols={15} />
      }
    </>)
}



const AddNewParty = ({ partyData, isDisabledflg = false, setView }) => {
  const [promotorSections, setPromotorSections] = useState([0]);
  const [metaData, setMData] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const swal = useSwalWrapper();
  async function getmetaData(data = '') {
    let transactionData = await jwtAuthAxios.get(`master/helper?${data}`).then(data => {
      setMData(data.data.data)
    })
    return
  }
  useEffect(async () => {
    if (!partyData) {
      await getmetaData(`term=1&paramsData=SHIPPEDBY,NATUREOFORGANISATION,BNUSINESSTYPE,LEADSOURCE,ACCOUNTTYPE,BRANCHCODE,PARTYGROUP&salesman=1&staff=AUTHPERSON,ACCOUNTMANGER&broker=1`)
    }

  }, [])


  const addPromotorSection = async () => {
    const newSections = [...promotorSections, promotorSections.length];
    await setPromotorSections(newSections);
    return
  };

  const removePromotorSection = (sectionIndex) => {
    const newSections = promotorSections.filter((index) => index !== sectionIndex);
    setPromotorSections(newSections);
  };

  const formik = useFormik({
    initialValues: {
      FL_PARTY_NAME: '',
      FL_PARTY_ADDR1: '',
      FL_PARTY_ADDR2: '',
      FL_PARTY_COUNTRY: '',
      FL_PARTY_STATE: '',
      FL_PARTY_CITY: '',
      FL_PARTY_ZIPCODE: '',
      FL_PARTY_PHONENO: '',
      FL_PARTY_FAXNO: '',
      FL_PARTY_EMAIL: '',
      FL_PARTY_TERMCODE: '',
      FL_PARTY_WEBSITE: '',
      FL_PARTY_SHIPCODE: '',
      FL_PARTY_NAT_OF_ORG: '', // Add Nature of Organization
      FL_PARTY_BUSINESS_TYPE: '', // Add Business Type
      FL_PARTY_TRAD_MEMR: '', // Add Business Registration No
      kycUpload: null, // Add KYC Upload
      FL_PARTY_REF_FLG: 'N',
      FL_PARTY_REF_CNAME: [1, 2, 3].map(() => ''),
      FL_PARTY_REF_PER_NAME: [1, 2, 3].map(() => ''),
      FL_PARTY_REF_PER_PHNO: [1, 2, 3].map(() => ''),
      FL_NARRATION: '', // Narration
      FL_PARTY_AUTR_PERSON: '',
      FL_PARTY_LIMIT: '',
      FL_ACCOUNT_MANAGER: '',
      FL_CREATED_BY: '',
      FL_PARTY_BROKER: '',
      FL_SALES_EXECUTIVE: '',
      FL_PARTY_LEAD_OF_SOURCE: '',
      FL_PARTY_TYPE: '',
      FL_PARTY_BANK_NAME: '',
      FL_PARTY_BANK_ACNO: '',
      FL_PARTY_BANK_BR_NAME: '',
      FL_PARTY_BANK_BR_ADDR: '',
      FL_PARTY_BANK_AC_TYPE: '',
      FL_PARTY_BANK_IFSC_TYPE: '',
      FL_PARTY_BANK_IFSC_NO: '',
      FL_PARTY_AC_PER_NAME: '',
      // acc_lastName: '',
      acc_phoneCountryCode: '',
      acc_phoneNo: '',
      // acc_faxCountryCode: '',
      // acc_faxNo: '',
      FL_PARTY_AC_PER_EMAIL: '',

    },
    validationSchema,
    onSubmit: async (values) => {
      // Handle form submission here
      if ((values.FL_PARTY_REF_FLG == 'N' || (await atLeastTwoValuesRequired(values.FL_PARTY_REF_CNAME) && await atLeastTwoValuesRequired(values.FL_PARTY_REF_PER_NAME) && await atLeastTwoValuesRequired(values.FL_PARTY_REF_PER_PHNO)))) {
        const formData = new FormData();

        // Loop through the keys of the values object
        await Object.keys(values).forEach((fieldName) => {
          // Append the field name and its value to the form data
          formData.set(fieldName, values[fieldName]);
        });
        formData.set('FL_PARTY_AC_PER_PHNO', `${values.acc_phoneCountryCode + ' ' + values.acc_phoneNo}`)
        // formData.append('FL_PARTY_AC_PER_PHNO', `${values.acc_phoneCountryCode+' '+values.acc_phoneNo}`)
        // console.log(formData);
        jwtAuthAxios.post(partyData != null ? 'master/party/update' : 'master/party', formData).then(response => {
          swal.fire({
            icon: 'success',
            text: response.data.message,
          })
          setView(null)
        }).catch(e => {
          swal.fire({
            icon: 'error',
            text: 'internal server error',
          })
        })
      }
      // else if(values.kycUpload == null){
      //   swal.fire({
      //     icon:'error',
      //     text:'Please Upload kyc',
      //   })
      // }
      // else if(values.promotorPhotoUpload == null){
      //   swal.fire({
      //     icon:'error',
      //     text:'Please Upload Promotor Photo',
      //   })
      // }
      else {
        swal.fire({
          icon: 'error',
          text: 'Please Enter Refrence',
        }).catch(e => {
          swal.fire({
            icon: 'error',
            text: 'internal server error',
          })
        })
      }
    }
  });
  // console.log(formik.values);
  useEffect(async () => {
    // console.log(partyData);
    if (partyData) {
      setIsDisabled(isDisabledflg)
      await getmetaData(`term=1&paramsData=SHIPPEDBY,NATUREOFORGANISATION,BNUSINESSTYPE,LEADSOURCE,ACCOUNTTYPE,BRANCHCODE,PARTYGROUP&staff=AUTHPERSON,ACCOUNTMANGER&broker=1&salesman=1`).then(async (e) => {
        await Object.keys(partyData.partyData[0]).forEach((fieldName) => {
          // Append the field name and its value to the form data
          formik.setFieldValue(fieldName, partyData.partyData[0][fieldName])
          // formData.append(fieldName, values[fieldName]);
        });
        formik.setFieldValue('FL_PARTY_REF_CNAME', [partyData.partyData[0]['FL_PARTY_REF_CNAME1'], partyData.partyData[0]['FL_PARTY_REF_CNAME2'], partyData.partyData[0]['FL_PARTY_REF_CNAME3']])
        formik.setFieldValue('FL_PARTY_REF_PER_NAME', [partyData.partyData[0]['FL_PARTY_REF_PER_NAME1'], partyData.partyData[0]['FL_PARTY_REF_PER_NAME2'], partyData.partyData[0]['FL_PARTY_REF_PER_NAME3']])
        formik.setFieldValue('FL_PARTY_REF_PER_PHNO', [partyData.partyData[0]['FL_PARTY_REF_PER_PHNO1'], partyData.partyData[0]['FL_PARTY_REF_PER_PHNO2'], partyData.partyData[0]['FL_PARTY_REF_PER_PHNO3']])
        formik.setFieldValue('acc_phoneCountryCode', partyData.partyData[0]['FL_PARTY_AC_PER_PHNO']?.split(' ')[0])
        formik.setFieldValue('acc_phoneNo', partyData.partyData[0]['FL_PARTY_AC_PER_PHNO']?.split(' ')[1])
      })
      let indexOFPromoter = []
      await partyData?.PROMOTERDETAIL.forEach(async (item, index) => {
        // console.log(item);
        indexOFPromoter.push(index)
        await addPromotorSection().then(
          async () => {
            await formik.setFieldValue('FL_PARTY_PROMO_SRNO' + index, item.FL_PARTY_PROMO_SRNO)
            await formik.setFieldValue('promotorFirstName' + index, item.FL_PARTY_PROMO_FIRST_NAME)
            await formik.setFieldValue('promotorLastName' + index, item.FL_PARTY_PROMO_LAST_NAME)
            await formik.setFieldValue('promotorDesignation' + index, item.FL_PARTY_PROMO_DESIGNATION)
            await formik.setFieldValue('promotorEmail' + index, item.FL_PARTY_PROMO_EMAIL)
            await formik.setFieldValue('promotorCountryCode' + index, item.FL_PARTY_PROMO_MOBILNO.split(' ')[0])
            await formik.setFieldValue('promotorMobileNo' + index, item.FL_PARTY_PROMO_MOBILNO.split(' ')[1])
          })
      })
      setPromotorSections(indexOFPromoter)

    }
  }, [partyData])

  return (
    <form onSubmit={formik.handleSubmit}>
      <JumboCardQuick title={"Company Details"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size='small'
              label="Company Name *"
              name="FL_PARTY_NAME"
              disabled={isDisabled}
              id='FL_PARTY_NAME'
              value={formik.values.FL_PARTY_NAME}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.FL_PARTY_NAME && Boolean(formik.errors.FL_PARTY_NAME)}
              helperText={formik.touched.FL_PARTY_NAME && formik.errors.FL_PARTY_NAME}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isDisabled}
              size='small'
              label="Address(Line 1) *"
              name="FL_PARTY_ADDR1"
              value={formik.values.FL_PARTY_ADDR1}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_ADDR1 && Boolean(formik.errors.FL_PARTY_ADDR1)}
              helperText={formik.touched.FL_PARTY_ADDR1 && formik.errors.FL_PARTY_ADDR1}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              size='small'
              disabled={isDisabled}
              label="Address(Line 2)"
              name="FL_PARTY_ADDR2"
              value={formik.values.FL_PARTY_ADDR2}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
            <TextField
              fullWidth
              disabled={isDisabled}
              label="Country *"
              size='small'
              name="FL_PARTY_COUNTRY"
              value={formik.values.FL_PARTY_COUNTRY}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_COUNTRY && Boolean(formik.errors.FL_PARTY_COUNTRY)}
              helperText={formik.touched.FL_PARTY_COUNTRY && formik.errors.FL_PARTY_COUNTRY}
            />
              {/* <InputLabel  size='small' id="Countryabel">Country *</InputLabel>
              <Select
                labelId="Countryabel"
                fullWidth
                disabled={isDisabled}
                label="Country"
                name="FL_PARTY_COUNTRY"
                value={formik.values.FL_PARTY_COUNTRY}
                onChange={async e => {
                  formik.handleChange(e);
                  await jwtAuthAxios.get(`master/helper?state=${e.target.value}`).then(data => { setMData({ ...metaData, ...data.data.data }) })
                }
                }
                error={formik.touched.country && Boolean(formik.errors.FL_PARTY_COUNTRY)}
                helperText={formik.touched.country && formik.errors.FL_PARTY_COUNTRY}
              >
                <MenuItem value="">Select Country</MenuItem>
                {metaData?.COUNTRY?.map((item, i) =>

                  <MenuItem key={i} value={item.FL_COUNTRY_CD}>{item.FL_COUNTRY_NAME}</MenuItem>
                )}
              </Select> */}
                {/* <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_COUNTRY && formik.errors.FL_PARTY_COUNTRY}</span> */}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
            <TextField
              fullWidth
              disabled={isDisabled}
              size='small'
              label="State *"
              name="FL_PARTY_STATE"
              value={formik.values.FL_PARTY_STATE}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_STATE && Boolean(formik.errors.FL_PARTY_STATE)}
              helperText={formik.touched.FL_PARTY_STATE && formik.errors.FL_PARTY_STATE}
            />
              {/* <InputLabel  size='small' id="statelabel">State *</InputLabel>
              <Select
                labelId="statelabel"
                fullWidth
                disabled={isDisabled}
                label="State"
                name="FL_PARTY_STATE"
                value={formik.values.FL_PARTY_STATE}
                onChange={async e => {
                  formik.handleChange(e);
                  await jwtAuthAxios.get(`master/helper?city=${e.target.value}`).then(data => { setMData({ ...metaData, ...data.data.data }) })
                }}
                error={formik.touched.FL_PARTY_STATE && Boolean(formik.errors.FL_PARTY_STATE)}
              >
                <MenuItem value="">Select State</MenuItem>
                {metaData?.STATE?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_STATE_CD}>{item.FL_STATE_NAME}</MenuItem>
                )}
              </Select>
              <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_STATE && formik.errors.FL_PARTY_STATE}</span> */}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
            <TextField
              fullWidth
              size='small'
              disabled={isDisabled}
              label="City *"
              name="FL_PARTY_CITY"
              value={formik.values.FL_PARTY_CITY}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_CITY && Boolean(formik.errors.FL_PARTY_CITY)}
              helperText={formik.touched.FL_PARTY_CITY && formik.errors.FL_PARTY_CITY}
            />
              {/* <InputLabel  size='small' id="CityLabel">City *</InputLabel>
              <Select
                labelId="CityLabel"
                fullWidth
                disabled={isDisabled}
                label=""
                name="FL_PARTY_CITY"
                value={formik.values.FL_PARTY_CITY}
                onChange={formik.handleChange}
                error={formik.touched.FL_PARTY_CITY && Boolean(formik.errors.FL_PARTY_CITY)}
                helperText={formik.touched.FL_PARTY_CITY && formik.errors.FL_PARTY_CITY}
              >
                <MenuItem value="">Select City</MenuItem>
                {metaData?.CITY?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_CITY_CD}>{item.FL_CITY_NAME}</MenuItem>
                )}
              </Select>
              <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_CITY && formik.errors.FL_PARTY_CITY}</span> */}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              size='small'
              disabled={isDisabled}
              label="Postal Code"
              name="FL_PARTY_ZIPCODE"
              value={formik.values.FL_PARTY_ZIPCODE}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_ZIPCODE && Boolean(formik.errors.FL_PARTY_ZIPCODE)}
              helperText={formik.touched.FL_PARTY_ZIPCODE && formik.errors.FL_PARTY_ZIPCODE}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isDisabled}
              size='small'
              label="Phone No"
              name="FL_PARTY_PHONENO"
              value={formik.values.FL_PARTY_PHONENO}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_PHONENO && Boolean(formik.errors.FL_PARTY_PHONENO)}
              helperText={formik.touched.FL_PARTY_PHONENO && formik.errors.FL_PARTY_PHONENO}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isDisabled}
              label="Fax No"
              size='small'
              name="FL_PARTY_FAXNO"
              value={formik.values.FL_PARTY_FAXNO}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isDisabled}
              label="Email"
              size='small'
              name="FL_PARTY_EMAIL"
              value={formik.values.FL_PARTY_EMAIL}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_EMAIL && Boolean(formik.errors.FL_PARTY_EMAIL)}
              helperText={formik.touched.FL_PARTY_EMAIL && formik.errors.FL_PARTY_EMAIL}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel  size='small' id="paymentTermsLabel">Payment Terms</InputLabel>
              <Select
                labelId="paymentTermsLabel"
                name="FL_PARTY_TERMCODE"
                disabled={isDisabled}
                value={formik.values.FL_PARTY_TERMCODE}
                onChange={formik.handleChange}
                size='small'
                error={formik.touched.FL_PARTY_TERMCODE && Boolean(formik.errors.FL_PARTY_TERMCODE)}
              >
                <MenuItem value="">Select Payment Terms</MenuItem>
                {metaData?.TERM?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_TERM_CODE}>{item.FL_TERM_NAME}</MenuItem>
                )}
                {/* Add more payment terms as needed */}
              </Select>
              <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_TERMCODE && formik.errors.FL_PARTY_TERMCODE}</span>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isDisabled}
              label="WEBSITE"
              name="FL_PARTY_WEBSITE"
              size='small'
              value={formik.values.FL_PARTY_WEBSITE}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel  size='small' id="shippedByLabel">Shipped By</InputLabel>
              <Select
                labelId="shippedByLabel"
                name="FL_PARTY_SHIPCODE"
                disabled={isDisabled}
                size='small'
                value={formik.values.FL_PARTY_SHIPCODE}
                onChange={formik.handleChange}
                error={formik.touched.FL_PARTY_SHIPCODE && Boolean(formik.errors.FL_PARTY_SHIPCODE)}
              >
                <MenuItem value="">Select Shipped By</MenuItem>
                {metaData?.SHIPPEDBY?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
                {/* <MenuItem value="carrier1">Carrier 1</MenuItem>
                <MenuItem value="carrier2">Carrier 2</MenuItem> */}
                {/* Add more shipped by options as needed */}
              </Select>
              <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_SHIPCODE && formik.errors.FL_PARTY_SHIPCODE}</span>
            </FormControl>
          </Grid>
        </Grid>
      </JumboCardQuick>
      <JumboCardQuick title={"Business Information"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }} sx={{ mt: 5 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel  size='small' id="FL_PARTY_NAT_OF_ORGLabel">Nature of Organization</InputLabel>
              <Select
                labelId="FL_PARTY_NAT_OF_ORGLabel"
                name="FL_PARTY_NAT_OF_ORG"
                disabled={isDisabled}
                size='small'
                value={formik.values.FL_PARTY_NAT_OF_ORG}
                onChange={formik.handleChange}
                error={formik.touched.FL_PARTY_NAT_OF_ORG && Boolean(formik.errors.FL_PARTY_NAT_OF_ORG)}
              >
                <MenuItem value="">Select Nature of Organisation</MenuItem>
                {metaData?.NATUREOFORGANISATION?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
                {/* Add more options as needed */}
              </Select>
              <span style={{ color: 'red' }}>
                {formik.touched.FL_PARTY_NAT_OF_ORG && formik.errors.FL_PARTY_NAT_OF_ORG}
              </span>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel  size='small' id="FL_PARTY_BUSINESS_TYPELabel">Business Type</InputLabel>
              <Select
                labelId="FL_PARTY_BUSINESS_TYPELabel"
                name="FL_PARTY_BUSINESS_TYPE"
                disabled={isDisabled}
                value={formik.values.FL_PARTY_BUSINESS_TYPE}
                onChange={formik.handleChange}
                size='small'
                error={formik.touched.FL_PARTY_BUSINESS_TYPE && Boolean(formik.errors.FL_PARTY_BUSINESS_TYPE)}
              >
                <MenuItem value="">Select Business Type</MenuItem>
                {metaData?.BNUSINESSTYPE?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
                {/* <MenuItem value="type1">Type 1</MenuItem>
                <MenuItem value="type2">Type 2</MenuItem> */}
                {/* Add more options as needed */}
              </Select>
              <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_BUSINESS_TYPE && formik.errors.FL_PARTY_BUSINESS_TYPE}</span>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Business Registration No"
              name="FL_PARTY_TRAD_MEMR"
              disabled={isDisabled}
              size='small'
              fullWidth
              value={formik.values.FL_PARTY_TRAD_MEMR}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_TRAD_MEMR && Boolean(formik.errors.FL_PARTY_TRAD_MEMR)}
              helperText={formik.touched.FL_PARTY_TRAD_MEMR && formik.errors.FL_PARTY_TRAD_MEMR}
            />
          </Grid>
          <Grid item xs={6}>
            {/* {!formik?.values?.FL_PARTY_CODE && */}
            <FormControl fullWidth>
              <InputLabel  size='small' htmlFor="kycUpload" shrink>KYC Upload</InputLabel>
              <Input
                id="kycUpload"
                name="kycUpload"
                type="file"
                disabled={isDisabled}
                inputProps={{
                  accept: 'image/*',
                }}
                onChange={(event) => formik.setFieldValue('kycUpload', event.currentTarget.files[0])}
                error={formik.touched.kycUpload && Boolean(formik.errors.kycUpload)}
              />
              <span style={{ color: 'red' }}>{formik.touched.kycUpload && formik.errors.kycUpload}</span>
            </FormControl>
            {/* } */}
          </Grid>

        </Grid>
      </JumboCardQuick>
      <JumboCardQuick title={"Additional Information"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }} sx={{ mt: 5 }}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup
              name="FL_PARTY_REF_FLG"
              value={formik.values.FL_PARTY_REF_FLG}
              onChange={formik.handleChange}
              disabled={isDisabled}
              row
            >
              <FormControlLabel
                value="Y"
                control={<Radio color="primary" />}
                label={<Typography style={{ color: '#381E86' }}><u>Reference(minimum two)</u></Typography>}
              />
              <FormControlLabel
                value="N"
                control={<Radio color="primary" />}
                label={<Typography style={{ color: '#381E86' }}><u>No Reference(Advance Pay Only)</u></Typography>}
              />
            </RadioGroup>
          </FormControl>
          <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_REF_PER_PHNO && formik.errors.FL_PARTY_REF_PER_PHNO}</span>
          <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_REF_PER_NAME && formik.errors.FL_PARTY_REF_PER_NAME}</span>
          <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_REF_CNAME && formik.errors.FL_PARTY_REF_CNAME}</span>
          <span style={{ color: 'red' }}>{formik.touched.FL_PARTY_REF_FLG && formik.errors.FL_PARTY_REF_FLG}</span>
        </Grid>

        {/* <Grid container spacing={2}> */}
        {formik.values.FL_PARTY_REF_FLG == 'Y' && formik.values.FL_PARTY_REF_CNAME.map((_, index) => (
          <Grid container spacing={2} key={index}>
            <Grid item sx={{ mb: 1.3 }} xs={4}>
              <TextField
                name={`FL_PARTY_REF_CNAME[${index}]`}
                label="Company Name"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values.FL_PARTY_REF_CNAME[index]}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item sx={{ mb: 1.3 }} xs={4}>
              <TextField
                name={`FL_PARTY_REF_PER_NAME[${index}]`}
                label="Contact Person"
                size='small'
                fullWidth
                disabled={isDisabled}
                value={formik.values.FL_PARTY_REF_PER_NAME[index]}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item sx={{ mb: 1.3 }} xs={4}>
              <TextField
                name={`FL_PARTY_REF_PER_PHNO[${index}]`}
                label="Contact No."
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values.FL_PARTY_REF_PER_PHNO[index]}
                onChange={formik.handleChange}
              />
            </Grid>

          </Grid>
        ))}
        <Grid item xs={8}>
          <TextField
            name="FL_NARRATION"
            label="Narration"
            size='small'
            fullWidth
            disabled={isDisabled}
            value={formik.values.FL_NARRATION}
            onChange={formik.handleChange}
            rows={5} // Number of rows
          />
        </Grid>
        <Grid container sx={{ mt: 5 }} spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Authorized By</InputLabel>
              <Select
                disabled={isDisabled}
                name="FL_PARTY_AUTR_PERSON"
                size='small'
                value={formik.values.FL_PARTY_AUTR_PERSON}
                onChange={formik.handleChange}
                label="Authorized By"
                error={formik.touched.FL_PARTY_AUTR_PERSON && Boolean(formik.errors.FL_PARTY_AUTR_PERSON)}
                helperText={formik.touched.FL_PARTY_AUTR_PERSON && formik.errors.FL_PARTY_AUTR_PERSON}
              >
                <MenuItem value="">Select AuthorisedBy</MenuItem>
                {/* Add your AuthorisedBy options here */}
                {metaData?.AUTHPERSON?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_USER_ID}>{item.FL_NAME}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_PARTY_AUTR_PERSON && formik.errors.FL_PARTY_AUTR_PERSON && (
                <div className="error">{formik.errors.FL_PARTY_AUTR_PERSON}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_LIMIT"
              label="Limit ($ )"
              fullWidth
              size='small'
              disabled={isDisabled}
              value={formik.values.FL_PARTY_LIMIT}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_LIMIT && Boolean(formik.errors.FL_PARTY_LIMIT)}
              helperText={formik.touched.FL_PARTY_LIMIT && formik.errors.FL_PARTY_LIMIT}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Account Manager</InputLabel>
              <Select
                disabled={isDisabled}
                size='small'
                name="FL_ACCOUNT_MANAGER"
                value={formik.values.FL_ACCOUNT_MANAGER}
                onChange={formik.handleChange}
                label="Account Manager	"
              >
                <MenuItem value="">Select accountManager</MenuItem>
                {metaData?.ACCOUNTMANGER?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_USER_ID}>{item.FL_NAME}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_ACCOUNT_MANAGER && formik.errors.FL_ACCOUNT_MANAGER && (
                <div className="error">{formik.errors.FL_ACCOUNT_MANAGER}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
          <FormControl fullWidth variant="outlined" error={formik.errors.FL_SALES_EXECUTIVE}>
              <InputLabel  size='small'>Sales Excutive</InputLabel>
              <Select
                disabled={isDisabled}
                size='small'
                name="FL_SALES_EXECUTIVE"
                value={formik.values.FL_SALES_EXECUTIVE}
                onChange={formik.handleChange}
                label="Sales Excutive	"
              >
                <MenuItem value="">Select accountManager</MenuItem>
                {metaData?.SALESMAN?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_USER_ID}>{item.FL_NAME}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_SALES_EXECUTIVE && formik.errors.FL_SALES_EXECUTIVE && (
                <div className="error">{formik.errors.FL_SALES_EXECUTIVE}</div>
              )}
            </FormControl>
            {/* <TextField
              name="Sales Executive"
              disabled
              size='small'
              label="FL_SALES_EXECUTIVE"
              fullWidth
              value={formik.values.FL_SALES_EXECUTIVE}
            /> */}
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Broker Name</InputLabel>
              <Select
                name="FL_PARTY_BROKER"
                value={formik.values.FL_PARTY_BROKER}
                size='small'
                onChange={formik.handleChange}
                disabled={isDisabled}
                label="Broker Name"
              >
                <MenuItem value="">Select brokerName</MenuItem>
                {/* Add your AuthorisedBy options here */}
                {metaData?.BROKER?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_PARTY_CODE}>{item.FL_PARTY_NAME}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_PARTY_BROKER && formik.errors.FL_PARTY_BROKER && (
                <div className="error">{formik.errors.FL_PARTY_BROKER}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Lead Source</InputLabel>
              <Select
                name="FL_PARTY_LEAD_OF_SOURCE"
                value={formik.values.FL_PARTY_LEAD_OF_SOURCE}
                onChange={formik.handleChange}
                size='small'
                disabled={isDisabled}
                label="Lead Source"
              >
                <MenuItem value="">Select leadSource</MenuItem>
                {/* Add your AuthorisedBy options here */}
                {metaData?.LEADSOURCE?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_PARTY_LEAD_OF_SOURCE && formik.errors.FL_PARTY_LEAD_OF_SOURCE && (
                <div className="error">{formik.errors.FL_PARTY_LEAD_OF_SOURCE}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined" error={formik.errors.FL_PARTY_TYPE}>
              <InputLabel  size='small'> Party Group	</InputLabel>
              <Select
                name="FL_PARTY_TYPE"
                value={formik.values.FL_PARTY_TYPE}
                disabled={isDisabled}
                size='small'
                onChange={formik.handleChange}
                label=" Party Group	"
              >
                <MenuItem value="">Select salesPartyGroup</MenuItem>
                {/* Add your AuthorisedBy options here */}
                {metaData?.PARTYGROUP?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
              </Select>
              {formik.touched.FL_PARTY_TYPE && formik.errors.FL_PARTY_TYPE && (
                <div className="error">{formik.errors.FL_PARTY_TYPE}</div>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </JumboCardQuick>
      <JumboCardQuick title={"Bank Details"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }} sx={{ mt: 5 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_BANK_NAME"
              label="Bank Name"
              disabled={isDisabled}
              fullWidth
              size='small'
              value={formik.values.FL_PARTY_BANK_NAME}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_BANK_NAME && Boolean(formik.errors.FL_PARTY_BANK_NAME)}
              helperText={formik.touched.FL_PARTY_BANK_NAME && formik.errors.FL_PARTY_BANK_NAME}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_BANK_ACNO"
              label="Account Number"
              disabled={isDisabled}
              fullWidth
              size='small'
              value={formik.values.FL_PARTY_BANK_ACNO}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_BANK_ACNO && Boolean(formik.errors.FL_PARTY_BANK_ACNO)}
              helperText={formik.touched.FL_PARTY_BANK_ACNO && formik.errors.FL_PARTY_BANK_ACNO}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_BANK_BR_NAME"
              label="Branch Name"
              disabled={isDisabled}
              size='small'
              fullWidth
              value={formik.values.FL_PARTY_BANK_BR_NAME}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_BANK_BR_NAME && Boolean(formik.errors.FL_PARTY_BANK_BR_NAME)}
              helperText={formik.touched.FL_PARTY_BANK_BR_NAME && formik.errors.FL_PARTY_BANK_BR_NAME}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_BANK_BR_ADDR"
              label="Branch Address"
              disabled={isDisabled}
              size='small'
              fullWidth
              value={formik.values.FL_PARTY_BANK_BR_ADDR}
              onChange={formik.handleChange}
              error={formik.touched.FL_PARTY_BANK_BR_ADDR && Boolean(formik.errors.FL_PARTY_BANK_BR_ADDR)}
              helperText={formik.touched.FL_PARTY_BANK_BR_ADDR && formik.errors.FL_PARTY_BANK_BR_ADDR}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Account Type</InputLabel>
              <Select
                name="FL_PARTY_BANK_AC_TYPE"
                disabled={isDisabled}
                size='small'
                value={formik.values.FL_PARTY_BANK_AC_TYPE}
                onChange={formik.handleChange}
                label="Account Type"
              >
                <MenuItem value="">Select Account Type</MenuItem>
                {metaData?.ACCOUNTTYPE?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
                {/* <MenuItem value="Current">Current</MenuItem>
                <MenuItem value="Savings">Savings</MenuItem> */}
              </Select>
              {formik.touched.FL_PARTY_BANK_AC_TYPE && Boolean(formik.errors.FL_PARTY_BANK_AC_TYPE) && (
                <div className="error">{formik.errors.FL_PARTY_BANK_AC_TYPE}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel  size='small'>Branch Code *</InputLabel>
              <Select
                name="FL_PARTY_BANK_IFSC_TYPE"
                value={formik.values.FL_PARTY_BANK_IFSC_TYPE}
                disabled={isDisabled}
                size='small'
                onChange={formik.handleChange}
                label="Branch Code"
              >
                <MenuItem value="">Select Branch Code</MenuItem>
                {metaData?.BRANCHCODE?.map((item, i) =>
                  <MenuItem key={i} value={item.FL_GPID}>{item.FL_PARA_VALUE}</MenuItem>
                )}
                {/* <MenuItem value="IFSC">IFSC</MenuItem>
                <MenuItem value="SWIFT">SWIFT</MenuItem>
                <MenuItem value="IBAN">IBAN</MenuItem> */}
              </Select>
              {formik.touched.FL_PARTY_BANK_IFSC_TYPE && Boolean(formik.errors.FL_PARTY_BANK_IFSC_TYPE) && (
                <div className="error">{formik.errors.FL_PARTY_BANK_IFSC_TYPE}</div>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_BANK_IFSC_NO"
              label="Branch IFSC"
              fullWidth
              disabled={isDisabled}
              value={formik.values.FL_PARTY_BANK_IFSC_NO}
              onChange={formik.handleChange}
              size='small'
              error={formik.touched.FL_PARTY_BANK_IFSC_NO && Boolean(formik.errors.FL_PARTY_BANK_IFSC_NO)}
              helperText={formik.touched.FL_PARTY_BANK_IFSC_NO && formik.errors.FL_PARTY_BANK_IFSC_NO}
            />
          </Grid>
        </Grid>
      </JumboCardQuick>
      <JumboCardQuick title={"Account Department Details"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }} sx={{ mt: 5 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_AC_PER_NAME"
              label="First Name"
              fullWidth
              disabled={isDisabled}
              value={formik.values.FL_PARTY_AC_PER_NAME}
              onChange={formik.handleChange}
              size='small'
              error={formik.touched.FL_PARTY_AC_PER_NAME && Boolean(formik.errors.FL_PARTY_AC_PER_NAME)}
              helperText={formik.touched.FL_PARTY_AC_PER_NAME && formik.errors.firstName}
            />
          </Grid>
          {/* <Grid item xs={6}>
            <TextField
              name="acc_lastName"
              label="Last Name"
              fullWidth
              value={formik.values.acc_lastName}
              onChange={formik.handleChange}
              error={formik.touched.acc_lastName && Boolean(formik.errors.acc_lastName)}
              helperText={formik.touched.acc_lastName && formik.errors.acc_lastName}
            />
          </Grid> */}
          <Grid item xs={6}>
            <TextField
              name="FL_PARTY_AC_PER_EMAIL"
              label="Email"
              fullWidth
              disabled={isDisabled}
              value={formik.values.FL_PARTY_AC_PER_EMAIL}
              onChange={formik.handleChange}
              size='small'
              error={formik.touched.FL_PARTY_AC_PER_EMAIL && Boolean(formik.errors.FL_PARTY_AC_PER_EMAIL)}
              helperText={formik.touched.FL_PARTY_AC_PER_EMAIL && formik.errors.FL_PARTY_AC_PER_EMAIL}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="acc_phoneCountryCode"
              label="Phone Country Code"
              fullWidth
              disabled={isDisabled}
              value={formik.values.acc_phoneCountryCode}
              onChange={formik.handleChange}
              size='small'
              error={formik.touched.acc_phoneCountryCode && Boolean(formik.errors.acc_phoneCountryCode)}
              helperText={formik.touched.acc_phoneCountryCode && formik.errors.acc_phoneCountryCode}
            />
          </Grid>
          <Grid item xs={9}>
            <TextField
              name="acc_phoneNo"
              label="Phone No"
              fullWidth
              disabled={isDisabled}
              value={formik.values.acc_phoneNo}
              onChange={formik.handleChange}
              size='small'
              error={formik.touched.acc_phoneNo && Boolean(formik.errors.acc_phoneNo)}
              helperText={formik.touched.acc_phoneNo && formik.errors.acc_phoneNo}
            />
          </Grid>
          {/* <Grid item xs={6}>
            <TextField
              name="acc_faxCountryCode"
              label="Fax Country Code"
              fullWidth
              value={formik.values.acc_faxCountryCode}
              onChange={formik.handleChange}
              error={formik.touched.acc_faxCountryCode && Boolean(formik.errors.acc_faxCountryCode)}
              helperText={formik.touched.acc_faxCountryCode && formik.errors.acc_faxCountryCode}
            />
          </Grid> */}
          {/* <Grid item xs={6}>
            <TextField
              name="acc_faxNo"
              label="Fax No"
              fullWidth
              value={formik.values.acc_faxNo}
              onChange={formik.handleChange}
              error={formik.touched.acc_faxNo && Boolean(formik.errors.acc_faxNo)}
              helperText={formik.touched.acc_faxNo && formik.errors.acc_faxNo}
            />
          </Grid> */}

        </Grid>
      </JumboCardQuick>
      <JumboCardQuick title={"Company Promotor Details"} wrapperSx={{ backgroundColor: 'background.paper', pt: 0 }} sx={{ mt: 5 }}>
        {promotorSections.map((sectionIndex) => (<div key={sectionIndex} >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h3" sx={{ mt: 3 }} gutterBottom>Promotor {sectionIndex + 1}</Typography>
            </Grid>
            <Grid item xs={6}>
              {/* {sectionIndex != 0 &&<Button type="button" variant="contained" color="error" onClick={() => removePromotorSection(sectionIndex)}>
            Remove Promotor
          </Button>} */}
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorFirstName${sectionIndex}`}
                label="Promotor First Name"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorFirstName${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorFirstName${sectionIndex}`])}
                helperText={formik.errors[`promotorFirstName${sectionIndex}`]}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorLastName${sectionIndex}`}
                label="Promotor Last Name"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorLastName${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorLastName${sectionIndex}`])}
                helperText={formik.errors[`promotorLastName${sectionIndex}`]}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorDesignation${sectionIndex}`}
                label="Promotor Designation"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorDesignation${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorDesignation${sectionIndex}`])}
                helperText={formik.errors[`promotorDesignation${sectionIndex}`]}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorEmail${sectionIndex}`}
                label="Promotor Email"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorEmail${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorEmail${sectionIndex}`])}
                helperText={formik.errors[`promotorEmail${sectionIndex}`]}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorCountryCode${sectionIndex}`}
                label="Promotor Country Code"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorCountryCode${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorCountryCode${sectionIndex}`])}
                helperText={formik.errors[`promotorCountryCode${sectionIndex}`]}
              />
            </Grid>
            <Grid item xs={10}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                name={`promotorMobileNo${sectionIndex}`}
                label="Promotor Mobile No"
                fullWidth
                size='small'
                disabled={isDisabled}
                value={formik.values[`promotorMobileNo${sectionIndex}`]}
                onChange={formik.handleChange}
                error={Boolean(formik.errors[`promotorMobileNo${sectionIndex}`])}
                helperText={formik.errors[`promotorMobileNo${sectionIndex}`]}
              />
            </Grid>
            {/* Photo Upload field */}
            {(sectionIndex == 0 && !partyData?.PROMOTERDETAIL) &&
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel  size='small' htmlFor="promotorPhotoUpload" shrink>Photo Id</InputLabel>
                  <Input
                    id="promotorPhotoUpload"
                    disabled={isDisabled}
                    name="promotorPhotoUpload"
                    type="file"
                    inputProps={{
                      accept: 'image/*',
                    }}
                    onChange={(event) => formik.setFieldValue('promotorPhotoUpload', event.currentTarget.files[0])}
                  />

                </FormControl>
              </Grid>
            }

          </Grid></div>
        ))}

        <Button type="button" variant="contained" color="primary" sx={{ mt: 3 }} onClick={addPromotorSection}>Add Promotor</Button>
      </JumboCardQuick>
      <Grid item sx={{ mt: 3 }} xs={6}>
        <LoadingButton sx={{ minWidth: 200, mx: 'auto', display: 'block' }} variant="contained" color="primary" type="submit">
          Submit
        </LoadingButton>
      </Grid>
    </form>
  );
};
Party.Modulename = 'Party'

export default Party;